<template>
  <div class="content bgimg-box" v-if="!this.subInfo && !loading">
    <div class="condition-box">
      <p v-if="provinceUniversityId[0] == 0">
        所填写的学校末开设CCMA方向班，请于05/05日上午10:00前填写联系方式，并上传团队介绍、老师推荐信及案例报告。主办方将在收到资料后，尽快与你联系，请注意查收邮件。<strong
          >资料只能提交一次，请谨慎提交！</strong
        >
      </p>
      <p v-else>
        请选择你所在的学校，如学校不在列表中，请选择“其他“进行填写。截止时间：05/05日上午10:00。
      </p>
    </div>
    <div class="team-info">
      <el-form :model="formData" label-width="120px">
        <el-form-item label="学校" required>
          <el-cascader
            v-model="provinceUniversityId"
            :options="provinceUniversityList"
            :props="{ value: 'id', label: 'name', children: 'universities' }"
            @change="handleChange"
            placeholder="请选择学校"
          ></el-cascader>
        </el-form-item>
        <el-form-item
          v-if="provinceUniversityId[0] == 0"
          label="学校名称"
          required
        >
          <el-input
            placeholder="请输入学校名称"
            v-model="formData.university_other"
          ></el-input>
        </el-form-item>
        <el-form-item
          v-if="provinceUniversityId[0] == 0"
          label="队长姓名"
          required
        >
          <el-input
            placeholder="请输入队长姓名"
            v-model="formData.leader_name"
          ></el-input>
        </el-form-item>
        <el-form-item
          v-if="provinceUniversityId[0] == 0"
          label="邮箱地址"
          required
        >
          <el-input
            placeholder="请输入邮箱地址"
            v-model="formData.leader_contact"
          ></el-input>
        </el-form-item>
        <el-form-item
          v-if="provinceUniversityId[0] == 0"
          label="手机号"
          required
        >
          <el-input
            placeholder="请输入手机号"
            v-model="formData.learder_mobile"
          ></el-input>
        </el-form-item>
        <el-form-item
          v-if="provinceUniversityId[0] == 0"
          label="团队介绍"
          required
        >
          <div
            class="file-box"
            style="margin-bottom: 0; padding: 0; background-color: unset"
          >
            <el-upload
              ref="uploadFile"
              class="upload-demo"
              :action="imgHost + '/user/upload'"
              :headers="uploadHeader"
              :on-preview="handlePreview"
              :data="uploadData"
              multiple
              :limit="1"
              :file-list="fileList"
              auto-upload
              :on-success="uploadSuccess1"
              :before-upload="beforeAvatarUpload"
              accept=".doc,.docx,.pdf"
            >
              <el-button size="small" type="primary">点击上传</el-button>
              <template #tip>
                <div class="el-upload__tip">只能上传word文件或pdf文件</div>
              </template>
            </el-upload>
          </div>
        </el-form-item>
        <el-form-item
          v-if="provinceUniversityId[0] == 0"
          label="案例报告"
          required
        >
          <div
            class="file-box"
            style="margin-bottom: 0; padding: 0; background-color: unset"
          >
            <el-upload
              ref="uploadFile"
              class="upload-demo"
              :action="imgHost + '/user/upload'"
              :headers="uploadHeader"
              :on-preview="handlePreview"
              :data="uploadData"
              multiple
              :limit="1"
              :file-list="fileList"
              auto-upload
              :on-success="uploadSuccess2"
              :before-upload="beforeAvatarUpload"
              accept=".doc,.docx,.pdf"
            >
              <el-button size="small" type="primary">点击上传</el-button>
              <template #tip>
                <div class="el-upload__tip">只能上传word文件或pdf文件</div>
              </template>
            </el-upload>
          </div>
        </el-form-item>
        <el-form-item
          v-if="provinceUniversityId[0] == 0"
          label="老师推荐信"
          required
        >
          <div
            class="file-box"
            style="margin-bottom: 0; padding: 0; background-color: unset"
          >
            <el-upload
              ref="uploadFile"
              class="upload-demo"
              :action="imgHost + '/user/upload'"
              :headers="uploadHeader"
              :on-preview="handlePreview"
              :data="uploadData"
              multiple
              :limit="1"
              :file-list="fileList"
              auto-upload
              :on-success="uploadSuccess3"
              :before-upload="beforeAvatarUpload"
              accept=".doc,.docx,.pdf"
            >
              <el-button size="small" type="primary">点击上传</el-button>
              <template #tip>
                <div class="el-upload__tip">
                  需备注老师邮箱/以及老师手写签名。只能上传word文件或pdf文件
                </div>
              </template>
            </el-upload>
          </div>
        </el-form-item>
        <el-form-item>
          <div class="team-button-box">
            <el-button class="pre" @click="sub" size="small" type="primary"
              >提交</el-button
            >
          </div>
        </el-form-item>
      </el-form>
    </div>
  </div>
  <div class="status-box" v-else-if="this.subInfo && !loading">
    <div class="img-box">
      <img src="../../assets/images/team/submit.png" alt="" />
      <p v-if="this.subInfo.university_province_id == 0">
        主办方将在收到资料后，尽快与你联系，请注意查收邮件。
      </p>
      <p v-else>请联系学校CCMA 方向班相关负责老师，获取更多赛事详情。</p>
    </div>
  </div>
</template>

<script>
import {
  apiGetProvinceUniversity,
  apiSubSchoolInfo,
  apiGetSubSchoolInfo,
  apiSetProcess,
} from "../../plugins/apis";
export default {
  data() {
    return {
      imgHost: process.env.VUE_APP_API_URL,
      uploadHeader: { Authorization: window.localStorage.app_token },
      fileList: [],
      uploadData: {},
      processData: {},
      provinceUniversityId: [],
      formData: {
        team_intro: "",
        university_zongshu: "",
        university_letter: "",
      },
      provinceUniversityList: [],
      subInfo: {},
      loading: true,
    };
  },
  watch: {},
  methods: {
    async view() {
      let res = await apiGetSubSchoolInfo(this.round.round_id);
      if (res.code === 200) {
        this.subInfo = res.data.data;

        console.log(77, this.subInfo);
      }
    },
    beforeAvatarUpload(file) {
      let fileArr = file.name.split(".");
      let bul = ["doc", "docx", "pdf"].indexOf(fileArr.pop()) > -1;
      if (bul) {
        return true;
      } else {
        this.$message.error("只能上传word文件或pdf文件");
        return false;
      }
    },
    handleChange(value) {
      console.log(88, value); // 这里的value是选中项的id数组
    },
    async getProvinceUniversity() {
      let res = await apiGetProvinceUniversity();
      if (res.code === 200) {
        this.provinceUniversityList = res.data;
        this.provinceUniversityList.push({ id: 0, name: "其他" });
      }
    },
    uploadSuccess1(e) {
      if (e.code === 200) {
        this.$message.success("上传成功");
        this.formData.team_intro = e.data.file.path;
        console.log(8, this.formData.team_intro);
      } else [this.$message.error("上传失败")];
    },
    uploadSuccess2(e) {
      if (e.code === 200) {
        this.$message.success("上传成功");
        this.formData.university_zongshu = e.data.file.path;
        console.log(9, this.formData.university_zongshu);
      } else [this.$message.error("上传失败")];
    },
    uploadSuccess3(e) {
      if (e.code === 200) {
        this.$message.success("上传成功");
        this.formData.university_letter = e.data.file.path;
        console.log(10, this.formData.university_letter);
      } else [this.$message.error("上传失败")];
    },
    handlePreview(file) {
      console.log(file);
    },

    async sub() {
      if (this.provinceUniversityId.length == 0 || !this.provinceUniversityId) {
        this.$message.error("请选择学校");
        return;
      }
      if (
        this.provinceUniversityId[0] == 0 &&
        !this.formData.university_other
      ) {
        this.$message.error("请输入学校名称");
        return;
      }
      if (this.provinceUniversityId[0] == 0 && !this.formData.leader_name) {
        this.$message.error("请输入队长姓名");
        return;
      }
      if (this.provinceUniversityId[0] == 0 && !this.formData.leader_contact) {
        this.$message.error("请输入邮箱地址");
        return;
      }
      if (this.provinceUniversityId[0] == 0 && !this.formData.learder_mobile) {
        this.$message.error("请输入手机号");
        return;
      }
      if (this.provinceUniversityId[0] == 0 && !this.formData.team_intro) {
        this.$message.error("请上传团队介绍");
        return;
      }
      if (
        this.provinceUniversityId[0] == 0 &&
        !this.formData.university_zongshu
      ) {
        this.$message.error("请上传案例综述");
        return;
      }
      if (
        this.provinceUniversityId[0] == 0 &&
        !this.formData.university_letter
      ) {
        this.$message.error("请上传老师推荐信");
        return;
      }
      this.$confirm("请确保所填信息准确无误，一经提交，将无法修改！", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          let _data = this.formData;
          _data.round_id = this.round.round_id;
          if (this.provinceUniversityId.length == 2) {
            _data.university_province_id = this.provinceUniversityId[0];
            _data.university_id = this.provinceUniversityId[1];
          } else {
            _data.university_province_id = this.provinceUniversityId[0];
            _data.university_id = "";
          }
          let res = await apiSubSchoolInfo(_data);
          if (res.code === 200) {
            this.$message.success("保存成功");
            await apiSetProcess(this.round.round_id, this.label);
            this.$Bus.$emit("reload_NowProcess");
            await this.view();
          } else {
            this.$message.error(res.message);
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
  },
  async mounted() {
    this.uploadData = {
      file_source: 1,
    };
    await this.getProvinceUniversity();
    await this.view();
    this.loading = false;
  },
  props: ["round", "label"],
};
</script> 

<style scoped>
.bgimg-box {
  background-color: #ffffff !important;
  background: url("../../assets/images/team/bg.png") no-repeat bottom right;
}

.el-textarea {
  width: 442px;
}

.el-tooltip {
  font-size: 12px;
}

.more {
  cursor: pointer;
  margin-left: 5px;
}

.more:hover {
  text-decoration: underline;
  color: #733085;
}
</style>

